import { render } from "./CreateLessonScreen.vue?vue&type=template&id=f2bdc050"
import script from "./CreateLessonScreen.vue?vue&type=script&lang=ts"
export * from "./CreateLessonScreen.vue?vue&type=script&lang=ts"

import "./CreateLessonScreen.vue?vue&type=style&index=0&id=f2bdc050&lang=scss"
script.render = render

export default script